var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "typeahead__container" }, [
    _c("div", { staticClass: "typeahead__field" }, [
      _c("span", { staticClass: "typeahead__query" }, [
        _c("i", { staticClass: "mdi mdi-map-marker" }),
        _vm._v(" "),
        _c("input", {
          ref: "input",
          staticClass: "uk-input",
          class: _vm.inputClass,
          attrs: {
            "data-wow-attr": _vm.inputDataWowAttr,
            name: _vm.inputName,
            type: _vm.inputType,
            autocomplete: _vm.inputAutocomplete,
            placeholder: _vm.inputPlaceholder
          },
          domProps: { value: _vm.inputValue }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }